import { ADD_PROCESS, REMOVE_PROCESS, LOGOUT_COMPLETE } from '../../constants/actionTypes';
import { findIndex } from 'lodash';

const initialState = {
  all: [],
  lastUpdated: null,
};

export const processesReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_PROCESS:
      return addProcess(state, action);

    case REMOVE_PROCESS:
      return removeProcess(state, action);

    case LOGOUT_COMPLETE:
      return initialState;

    default:
      return state;
  }
};

export default processesReducer;

function addProcess(state, action) {
  const {
    payload: { type, description, data, progressRequestType },
  } = action;
  const { all } = state;
  const process = { type, description, progressRequestType, ...data };

  if (findIndex(all, process) > -1) {
    return state;
  }

  return {
    ...state,
    all: [...all, process],
    lastUpdated: Date.now(),
  };
}

function removeProcess(state, action) {
  const {
    payload: { type, data },
  } = action;
  const { all } = state;
  const process = { type, ...data };
  const processIndex = findIndex(all, process);

  if (processIndex < 0) {
    return state;
  }

  const newProcesses = [...all];
  newProcesses.splice(processIndex, 1);

  return {
    ...state,
    all: newProcesses,
    lastUpdated: Date.now(),
  };
}
